module.exports = __webpack_public_path__ + "img/aeroland-pricing-image-06.e327fd6c.png";